import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { Button, Divider, Label, SreenCoverLoading } from "src/components";
import { useAlert, useConfirm, useRefetchEventBookings, useUserStepStatusEvent } from "src/hooks";
import { createTeeshotAxiosInstance } from "src/http";
import { recoilStates } from "src/recoil/recoilStates";
import STATIC_DATA from "src/staticData";
import { colors } from "src/styles/theme";
import { formatPhoneNumber, parseJsonStr } from "src/utils";
import styled from "styled-components";

export default function EventBookingRegisterResult() {
  const navigate = useNavigate();
  const [group] = useRecoilState(recoilStates.group);
  const [eventApplication] = useRecoilState(recoilStates.eventApplication);
  const [init] = useRecoilState(recoilStates.init);
  const [isCoverLoading, setIsCoverLoading] = useState(false);

  const alert = useAlert();

  // TODO: 수정

  const userStep = useUserStepStatusEvent();

  useEffect(() => {
    const isIllegal = eventApplication?.event_booking_rel_club?.some((r) => {
      return [4, 5, 6].includes(r.status_id || 0); // 취소 확정 만료건에선 표시X
    });
    (async () => {
      if (!init.isInit) {
        return;
      }
      if (isIllegal) {
        alert({ content: "비정상적인 접근", onClose: () => alert.resume() });
        await alert.pause();
        navigate("/event-booking");
      }
    })();
  }, [eventApplication, init]);

  const refetchData = useRefetchEventBookings();

  // useEffect(() => {
  //   if (!bookingApplication?.id) {
  //     (async () => {
  //       alert({ content: "부킹신청 내역이 없습니다.", onClose: () => alert.resume() });
  //       await alert.pause();

  //       navigate("/");
  //     })();
  //   }
  // }, []);

  const confirm = useConfirm();
  // const { PopupComponent: ApplyPopupComp, openPopup: openApplyPopupComp } = usePopupPage("apply");
  // return <>신청내역</>;

  return (
    <Container className="flex-1 d-flex fd-c gap-3">
      <h3 className="fs-5 fw-b">{group?.name}</h3>
      <Label className="bold" content={"희망 골프장"} />
      {eventApplication?.event_booking_rel_club?.map((club, index) => (
        <GolfClubCard key={club.id || index}>
          <TextWeight600>
            {index + 1}. {club.club?.name}
          </TextWeight600>
        </GolfClubCard>
      ))}
      <Label className="bold" content={"예약 정보"} />
      <RegisterCard>
        <CardLayout>
          <CardText>신청자</CardText>
          <TextWeight700>{eventApplication?.proposer_name || " - "}</TextWeight700>
        </CardLayout>
        <CardLayout>
          <CardText>연락처</CardText>
          <TextWeight700>
            {formatPhoneNumber(eventApplication?.proposer_contact || "") || " - "}
          </TextWeight700>
        </CardLayout>
        <CardLayout>
          <CardText>신청 팀수</CardText>
          <TextWeight700>{eventApplication?.team_amount} 팀</TextWeight700>
        </CardLayout>
        <CardLayout>
          <CardText>행사 성격</CardText>
          <TextWeight700>월간 부킹</TextWeight700>
        </CardLayout>
        <CardLayout>
          <CardText>행사명</CardText>
          <TextWeight700>{group?.name || " - "}</TextWeight700>
        </CardLayout>
      </RegisterCard>

      <Label className="bold" content={"객단가"} />
      <RegisterCard>
        <CardLayout>
          <CardText>객단가</CardText>
          <TextWeight700>
            {(() => {
              const priceId = eventApplication?.price_per_person_id;
              if (!priceId) {
                return " - ";
              }
              if (Number(priceId) && Number(priceId) < 5) {
                return `${priceId} 만원`;
              }
              return `${priceId} 만원 이상`;
            })()}
          </TextWeight700>
        </CardLayout>
      </RegisterCard>
      <Divider />
      <div className="d-flex fd-c gap-1">
        <Label className="bold" content={"시설이용"} />
        <RegisterCard>
          {[
            {
              label: "결제방식",
              value:
                STATIC_DATA.PAY_TYPE_DATA.find((d) => d.id === eventApplication?.payment_type_id)
                  ?.name || " - ",
            },
            {
              label: "식사 선택",
              value: eventApplication?.meal_type_id === 1 ? "이용" : " - ",
            },
            {
              label: "프로샵 이용",
              value: eventApplication?.proshop_item || " - ",
            },
            {
              label: "룸 이용",
              value:
                JSON.parse(eventApplication?.room_type_ids_json_str || "[]")
                  ?.map((id: number) => {
                    return { 1: "라운드 전", 2: "라운드 후" }[id];
                  })
                  ?.join(", ") || " - ",
            },
          ].map((item, index) => (
            <CardLayout key={index}>
              <CardText>{item.label}</CardText>
              <TextWeight700>{item.value}</TextWeight700>
            </CardLayout>
          ))}
        </RegisterCard>
      </div>
      <Label className="bold" content={"경기 및 시상"} />
      <RegisterCard>
        {[
          {
            label: "경기방식",
            value:
              STATIC_DATA.GAME_TYPE_DATA.find((d) => d.id === eventApplication?.game_type_id)
                ?.name || " - ",
          },
          {
            label: "티사용",
            value:
              STATIC_DATA.TEEBOX_TYPE_DATA.find((d) => d.id === eventApplication?.teebox_type_id)
                ?.name || " - ",
          },
          {
            label: "시상내용",
            value: (() => {
              const awards = parseJsonStr(eventApplication?.award_ids_arr_json_str || "");
              if (!awards || !awards.length) {
                return " - ";
              }
              return STATIC_DATA.AWARDS_DATA.filter((d) => awards.includes(d.id))
                .map((x) => x.name)
                .join(", ");
            })(),
          },
          {
            label: "요청사항",
            value:
              JSON.parse(eventApplication?.etc_requirement_ids_arr_json_str || "null")
                ?.map((rid: number) => {
                  return STATIC_DATA.ETC_REQ_DATA.find((d) => d.id === rid)?.name;
                })
                .join(", ") || " - ",
          },
        ].map((item, index) => (
          <CardLayout key={index}>
            <CardText isAward={item.label === "시상내용"}>{item.label}</CardText>
            <TextWeight700>{item.value}</TextWeight700>
          </CardLayout>
        ))}
      </RegisterCard>

      <Button
        $round
        className="mt-6"
        $colorTheme="white"
        $outline={true}
        $buttonSize="md"
        onClick={() => {
          confirm({
            title: "부킹취소",
            content: "정말로 부킹신청을 취소하시겠습니까?",
            onConfirm: () => {
              (async () => {
                try {
                  setIsCoverLoading(true);
                  const res = await createTeeshotAxiosInstance().post(
                    "/evtBooking/booking/user-cancel",
                    {
                      bookingId: eventApplication?.id,
                    }
                  );
                  if (!res.data.success) {
                    throw new Error(res.data.message || "취소실패");
                  }
                  await refetchData();
                  setIsCoverLoading(false);
                  alert({
                    content: "성공적으로 취소되었습니다.",
                    onClose: () => {
                      alert.resume();
                    },
                  });
                  await alert.pause();
                  navigate("/event-booking");
                } catch (e: any) {
                  setIsCoverLoading(false);
                  alert({
                    content: e?.message || "취소요청 실패",
                    onClose: () => {
                      alert.resume();
                    },
                  });
                  await alert.pause();
                  navigate("/event-booking");

                  window.location.reload();
                }
              })();
            },
          });
        }}
      >
        신청 취소하기
      </Button>
      {isCoverLoading && <SreenCoverLoading />}
    </Container>
  );
}

const Container = styled.div`
  padding: 16px;
  * {
    word-wrap: break-word;
    white-space: break-spaces;
    word-break: break-all;
  }
  label {
  }
  /* .dates-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
  } */

  .applier {
    background-color: ${colors.gray.third};
    padding: 5px;
  }
  .cols-container-55 {
    display: flex;
    gap: 5px;
    > :first-child {
      flex-basis: 55px;
    }
  }
  .cols-container-70 {
    display: flex;
    gap: 5px;
    > :first-child {
      flex-basis: 70px;
      flex-shrink: 0;
    }
  }
`;

const Card = styled.div`
  text-align: start;
  display: flex;
  flex-direction: column;
  padding: 19px 16px;
  background-color: #f0f0f4;
  border-radius: 6px;
  width: 100%;
  flex-shrink: 0;
`;

const RegisterCard = styled(Card)`
  gap: 10px;
`;

const GolfClubCard = styled(Card)`
  gap: 10px;
`;

const CardText = styled.div<{ isAward?: boolean }>`
  min-width: ${(props) => (props.isAward ? "80px" : "50px")};
`;

const TextWeight700 = styled.div`
  font-weight: 700;
`;

const TextWeight600 = styled.div`
  font-weight: 600;
`;

const CardLayout = styled.div`
  padding: 4px;
  display: flex;
  justify-content: space-between;
`;
